import config from "config.json";

let oneTrustListenerPresent = false;

const addOneTrustGroupsListener = () => {
	if (!oneTrustListenerPresent) {
		document?.addEventListener("OneTrustGroupsUpdated", () => {
			if (window?.sessionStorage && window?.OnetrustActiveGroups) {
				const oldGroups = window?.sessionStorage.getItem("ot");
				const currentGroups = window?.OnetrustActiveGroups;
				if (oldGroups !== currentGroups) {
					window?.sessionStorage.setItem("ot", currentGroups);
					window?.location.reload();
				}
			} else {
				window?.location.reload();
			}
		});
		oneTrustListenerPresent = true;
	}
};

const handleOneTrustModal = (event = {}, brand) => {
	event.preventDefault();
	if (config.brands[brand]?.addOneTrustGroupsListener) {
		addOneTrustGroupsListener();
	}
	const oneTrust = window?.OneTrust;
	if (oneTrust?.ToggleInfoDisplay) {
		oneTrust.ToggleInfoDisplay();
	} else {
		let isOneTrustModalPresent = false;
		const oneTrustModal = document?.getElementById("onetrust-pc-sdk");
		const oneTrustDarkFilter = document?.getElementsByClassName(
			"onetrust-pc-dark-filter"
		)?.[0];
		const oneTrustDisplay = "block";
		const oneTrustVisibility = "visible";
		const oneTrustOpacity = "1";
		const oneTrustHiddenClass = "ot-hide";

		if (oneTrustModal) {
			isOneTrustModalPresent = true;
			oneTrustModal.style.display = oneTrustDisplay;
			oneTrustModal.style.visibility = oneTrustVisibility;
			oneTrustModal.style.opacity = oneTrustOpacity;
			oneTrustModal.classList.remove(oneTrustHiddenClass);
		}

		if (oneTrustDarkFilter) {
			isOneTrustModalPresent = true;
			oneTrustDarkFilter.style.display = oneTrustDisplay;
			oneTrustDarkFilter.style.visibility = oneTrustVisibility;
			oneTrustDarkFilter.style.opacity = oneTrustOpacity;
			oneTrustDarkFilter.classList.remove(oneTrustHiddenClass);
		}

		if (!isOneTrustModalPresent) {
			console.error("OneTrust wasn't correctly loaded");
		}
	}
};

export { handleOneTrustModal };
